import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const ReactLogoIcon = React.memo(function ReactLogoIcon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <ellipse cx="7.5" cy="7.5" rx="7" ry="2.5" stroke={color} />
      <ellipse
        cx="7.5"
        cy="7.5"
        rx="7"
        ry="2.5"
        stroke={color}
        transform="rotate(60 7.5 7.5)"
      />
      <ellipse
        cx="7.5"
        cy="7.5"
        rx="7"
        ry="2.5"
        stroke={color}
        transform="rotate(-60 7.5 7.5)"
      />
    </svg>
  );
});
